/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Guide_Who_TitleInputs */

const en_fw_guide_who_title = /** @type {(inputs: Fw_Guide_Who_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who is making it?`)
};

const zh_fw_guide_who_title = /** @type {(inputs: Fw_Guide_Who_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`由谁制作？`)
};

/**
* | output |
* | --- |
* | "Who is making it?" |
*
* @param {Fw_Guide_Who_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_guide_who_title = /** @type {((inputs?: Fw_Guide_Who_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Guide_Who_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_guide_who_title(inputs)
	return zh_fw_guide_who_title(inputs)
});
export { fw_guide_who_title as "fw.guide.who.title" }